import React, { memo } from 'react';
import * as GStyled from '../../../styles/components';
import * as Styled from './styled';
import { ReportSnapshot } from '../../../models';
import { Icon } from '../../../components';
import { useFormatDateByLocale } from '../../../util/hooks/useFormatDateByLocale';

interface ReportSettingPITProps {
  reportSnapshot: ReportSnapshot;
}

function ReportSettingPIT({
  reportSnapshot,
}: ReportSettingPITProps): JSX.Element {
  const { asOfDate } = reportSnapshot;
  const formattedAsOfDate = useFormatDateByLocale(asOfDate);

  return (
    <>
      <Styled.ReportSettingItem hasSecondColumn={true}>
        <Icon name="pit" />
        <GStyled.Text>As Of Date</GStyled.Text>
        <GStyled.Text fontWeight="medium">{formattedAsOfDate}</GStyled.Text>
      </Styled.ReportSettingItem>
    </>
  );
}

export default memo(ReportSettingPIT);
